<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{mediaInfo.videoTitle}}
    </template>
    <template v-slot:content_right>
     <div class="mediaDetailContent">
       <div class="headerContent">
         <div class="icon_wrap" v-if="mediaInfo.authorUuid === userUuid">
<!--           <img-->
<!--             v-if="true"-->
<!--             class="icon"-->
<!--             title="收藏"-->
<!--             src="@/assets/images/common/star.png"-->
<!--             >-->
<!--           <img-->
<!--             v-else-->
<!--             class="icon"-->
<!--             src="@/assets/images/common/star_copy.png"-->
<!--             >-->
<!--           <div class="icon" style="display: flex;align-items: center">-->
<!--             <img-->
<!--               title="点赞"-->
<!--               style="display: inline-block"-->
<!--               src="@/assets/images/common/thumb.png"-->
<!--             >-->
<!--             <span >（0）</span>-->
<!--           </div>-->
<!--           <img-->
<!--             class="icon"-->
<!--             title="下载"-->
<!--             src="@/assets/images/common/down.png"-->
<!--           >-->
           <img
             @click="edit(mediaInfo.uuid)"
             class="icon"
             title="编辑"
             src="@/assets/images/common/edit.png"
           >
           <img
             class="icon"
             title="删除"
             @click="remove"
             src="@/assets/images/common/remove.png"
           >
         </div>
         <div class="optPermission">
           <div class="permission" v-if="mediaInfo.authorUuid === userUuid">
             <p class="permissionTitle">共享权限</p>
             <select v-model="sharingStatus" class="permissionSelect" @change="changeStatus">
               <option  v-for="(item,index) in shareStatusList" :value="item.status" :key="index">
                 {{item.name}}
               </option>
             </select>
           </div>
           <div class="updateTime">
             <p>更新时间：{{mediaInfo.updatedAt | time(true)}}</p>
           </div>
         </div>
       </div>
       <div class="mediaDownContent">
         <div class="left">
           <video
             v-if="mediaInfo.videoAddress"
             autoplay
             controls
             width="400"
             disablePictureInPicture
             :poster="mediaInfo.videoCoverAddress || ''"
             controlsList = "nodownload"
             height="260">
             <source :src="mediaInfo.videoAddress" type="video/mp4">
           </video>
         </div>
         <div class="right">
           <div class="intro">
             <img src="@/assets/images/common/player_information.png" alt="">
             <p style="margin-left: 20px;font-size: 18px">基本信息</p>
           </div>
           <div class="info">
             <p class="p_item">所属培训协会：{{mediaInfo.organShortName}}</p>
             <p class="p_item">所属培训机构：{{mediaInfo.youthShortName}}</p>
             <p class="p_item">上传人：{{mediaInfo.authorName}}</p>
             <p class="p_item">时长：{{filterTime(parseInt(mediaInfo.videoDuration / 60))}}:{{ filterTime(mediaInfo.videoDuration % 60)}}</p>
           </div>
         </div>
       </div>
       <div class="descriptMedia">
         <p>描述：{{mediaInfo.videoIntro}}</p>
       </div>
       <div class="media_link_list" v-if="players.length > 0 || plans.length > 0 || matchReports.length > 0 || events.length > 0 || scouts.length >0">
         <p>本视频已关联：</p>
         <p v-if="players.length > 0" style="margin-left:30px">{{players.length}}名球员<span @click="lookDetail('player')" class="look">（查看）</span> </p>
         <p v-if="plans.length > 0" style="margin-left:30px">{{plans.length}}个教案<span @click="lookDetail('plan')" class="look">（查看）</span> </p>
         <p v-if="matchReports.length > 0" style="margin-left:30px">{{matchReports.length}}个比赛<span @click="lookDetail('matchReport')" class="look">（查看）</span> </p>
         <p v-if="events.length > 0" style="margin-left:30px">{{events.length}}个训练计划<span @click="lookDetail('event')" class="look">（查看）</span> </p>
         <p v-if="scouts.length > 0" style="margin-left:30px">{{scouts.length}}个球探报告<span @click="lookDetail('scout')" class="look">（查看）</span> </p>
       </div>
     </div>
      <yioks-tip :showTip="removeTarget" :tipMsg="tips" @callback="removeMedia"></yioks-tip>
      <template v-if="showDialog">
        <Detail :showDialog.sync="showDialog" :linkList="list" :type="type"></Detail>
      </template>
    </template>
  </SubContent>
</template>

<script>
import media from '@/api/media'
import { shareStatusList } from '@/utils/yioks_data'
import storage from '@/utils/storage'
export default {
  name: 'index',
  components: {
    'SubContent': () => import('@/components/layout/list'),
    'Detail': () => import('@/components/associatedDialog/detail')
  },
  data () {
    return {
      tips: '确定删除该视频吗？',
      shareStatusList,
      userUuid: storage.get('userInfo').uuid,
      mediaInfo: {},
      uuid: this.$route.query.uuid,
      sharingStatus: '',
      events: [],
      scouts: [],
      matchReports: [],
      removeTarget: false,
      plans: [],
      players: [],
      list: [],
      showDialog: false,
      type: ''
    }
  },
  created () {
    this.getMediaInfo()
  },
  methods: {
    getMediaInfo () {
      media.videoDetail(this.uuid).then(res => {
        this.mediaInfo = { ...res.video }
        this.sharingStatus = res.video.sharingStatus
        const { events, matchReports, plans, players ,scouts} = res
        events.length > 0 && (this.events = events)
        matchReports.length > 0 && (this.matchReports = matchReports)
        plans.length > 0 && (this.plans = plans)
        scouts.length > 0 && (this.scouts = scouts)
        players.length > 0 && (this.players = players)
        // if(players && players.length) {
        //   this.players = players.map(item => {

        //   })
        // }
      })
    },
    remove () {
      this.removeTarget = true
    },
    changeStatus () {
      media.videoStatus({
        sharingStatus: this.sharingStatus,
        videoUuid: this.uuid
      }).then(res => {
        if (res.code) {
          this.$message.error(res.msg)
          this.sharingStatus = this.mediaInfo.sharingStatus
        } else {
          this.$message.success('修改成功')
        }
      }).catch(err =>{
        // this.$message.error('修改失败')
        this.sharingStatus = this.mediaInfo.sharingStatus
      })
    },
    edit (videoUuid) {
      this.$router.push({
        path: 'addMedia',
        query: {
          type: 'edit',
          videoUuid
        }
      })
    },
    removeMedia (flag) {
      if (flag) {
        media.videoRemove({ videoUuid: this.uuid }).then(res => {
          this.removeTarget = false
          if (res.code) {
            this.$message.error(res.msg)
          } else {
            this.$message.success('删除成功')
            this.$router.go(-1)
          }
        }).catch(err => {
          this.removeTarget = false
        })
      } else{
        this.removeTarget = false
      }

    },
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    lookDetail (type) {
      this.list = []
      this.type = type
      if (type === 'player') {
        this.list = [].concat(this.players)
      } else if (type === 'matchReport') {
        this.list = [].concat(this.matchReports)
      } else if (type === 'event') {
        this.list = [].concat(this.events)
      } else if (type === 'plan') {
        this.list = [].concat(this.plans)
      }else if (type === 'scout') {
        this.list = [].concat(this.scouts)
      }
      this.showDialog = true
    }
  }
}
</script>

<style scoped lang="stylus">
  video::-webkit-media-controls-enclosure
    overflow hidden
  video::-webkit-media-controls-panel
    width: calc(100%  + 30px)
  .mediaDetailContent
    padding 40px 20px  0
    .headerContent
      display flex
      align-items center
      padding-bottom 10px
      border-bottom  1px solid white
      .icon_wrap
        display flex
        width 100px
        justify-content center
        align-items center
        .icon
          margin-right 20px
          cursor pointer

      .optPermission
        display flex
        justify-content space-between
        align-items center
        flex  1 1 auto
        margin-left 30px
        .permission
          display flex
          align-items center
          .permissionTitle
            margin-right 15px
          .permissionSelect
            width 170px
            height 40px
    .mediaDownContent
      margin-top 20px
      display flex
      .left
        background-color black
      .right
        flex  1  1 auto
        padding-left 40px
        .intro
          display flex
          align-items center
          border-bottom  1px solid white
          padding-bottom 10px
        .info
          margin-top 25px
          .p_item
            margin-bottom 15px
    .descriptMedia
      margin-top 30px
    .media_link_list
      margin-top 15px
      p
        margin-bottom 10px
      .look
        cursor pointer
        color #4cd964
</style>
